<template>
    <div class="sendForum">
        <div class="sendForum-title">
            <el-input v-model="form.title" clearable placeholder="请输入标题"></el-input>
        </div>
        <div class="sendForum-content">
            <el-input v-model="form.content" type="textarea" :rows="5" clearable placeholder="请输入内容"></el-input>
        </div>
        <div class="sendForum-img">
            <!-- <UploadList width="200px" height="200px" v-model="detail.proof" :maxlength=num :status="status"></UploadList> -->
            <UploadList v-model="form.images" :maxlength=num></UploadList>
        </div>
        <!-- <div class="sendForum-btn" @click="sendPost">发布</div> -->
        <div class="but">
            <el-button :loading="loading" type="primary" class="sendForum-btn" @click.native.prevent="sendPost">发布</el-button>
        </div>
    </div>
</template>
<script>
import UploadList from '@/components/UploadList/index.vue'
import request from "@/utils/request";
export default {
    components: {UploadList},
    data(){
        return{
            num:9,
            form:{
                title:'',
                content:'',
                images:[]
            },
            loading:false,
        }
    },
    methods:{
        sendPost() {
            if(!this.form.title){
                this.$message.error("标题不能为空！")
                return
            }
            if(!this.form.content){
                this.$message.error("内容不能为空！")
                return
            }
            this.loading=true
            request({
                url: "/api/userend/post/releasedPost",
                method: "post",
                params: this.form
            }).then(response => {
                this.$message.success("发布成功")
                this.$notify({
                    title: "成功",
                    message: "发布成功",
                    type: "success",
                    duration: 2000
                });
                this.form={
                    title:'',
                    content:'',
                    images:[]
                }
                this.$parent.info()
                this.loading=false
                setTimeout(() => {
                    this.$router.push("/forum/list")
                }, 500);
            });
        },
    }
}
</script>

<style lang="scss">
.sendForum{
    padding: 20px 30px;
    .sendForum-title{
        .el-input__inner{
            height: 70px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            // color: #CCCCCC;
            border: none;
        }
        border-bottom: 1px solid #F9FAFD;
    }
    .sendForum-content{
        margin-top: 15px;
        .el-textarea__inner{
            border: none;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            // color: #CCCCCC;
            line-height: 30px;
        }
    }
    .sendForum-img{
        margin-top: 15px;
    }
    .but{
        display: flex;
        flex-direction: row;
        justify-content: center;
        .sendForum-btn{
            cursor: pointer;
            text-align: center;
            width: 315px;
            // margin: 0 auto;
            height: 50px;
            // line-height: 50px;
            background: #3D7EFF;
            border-radius: 6px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            margin-top: 350px;
        }
    }
}
</style>